export const MIN_LINE_ITEMS = 2;

export const invoiceDirtyMessages = ['Please save the document.'];
export const receiptDirtyMessages = ['Please save the receipt.'];
export const messageDirtyMessages = ['Please save the message.'];
